import LeadSourcePage from "../components/lead-source/mainCreateLead";

function CreateLeadSource() {
    return(<div><LeadSourcePage/></div>)
}

export default CreateLeadSource;